






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { SelectOptionData } from '../../../Pi/types'

@Component
export default class SelectedTopicTag extends Vue {
  @Prop({ type: Array }) selectedTopics!:Array<number>

  @Prop({ type: Array }) topics!:Array<SelectOptionData>

  get labeledTopics():string {
    return this.selectedTopics
      .slice()
      .map(this.getTopicLabel)
      .join(', ')
  }

  getTopicLabel(topicId:number):string {
    const topic = this.topics.find(t => t.value === topicId)

    if (topic) {
      return topic.label
    }

    return `${ topic ?? topicId } (не найден)`
  }
}
